<template>
    <div class="classroom" ref="classroom" v-html="svg">
    </div>
</template>

<script>
    import svg from '!raw-loader!@/assets/classroom.svg'

    export default {
        data() {
            return {
                svg: svg
            }
        },
        computed: {
            activeTechnologies(){
                return this.$store.getters['configurator/getActiveTechnologies']
            },
            hasActveTechnologies(){
                return this.$store.getters['configurator/hasActiveTechnologies']
            }
        },
        mounted(){
            this.render()
        },
        updated(){
            this.render()
        },
        methods: {
            render(){
                let classroom = this.$refs['classroom']
                let vm = this

                // Insert FadeIn Effect
                let style = document.createElement("style")
                style.innerHTML = `g { transition: opacity 0.5s ease; }`
                classroom.appendChild(style)

                // Initially hide all technologies
                classroom.querySelectorAll('.technology').forEach(function(el){
                    el.style.opacity = 0
                })

                // Show default environment if no technology is enabled
                classroom.querySelectorAll('.default').forEach(function(el){
                    el.style.opacity = (vm.hasActveTechnologies ? 0 : 1)
                })

                // Show digital environment if at least one technology is enabled
                classroom.querySelectorAll('.digital').forEach(function(el){
                    el.style.opacity = (vm.hasActveTechnologies ? 1 : 0)
                })

                // Hide analog environment if at least one technology is enabled
                classroom.querySelectorAll('.analog').forEach(function(el){
                    el.style.opacity = (vm.hasActveTechnologies ? 0 : 1)
                })

                // Show all enabled technologies
                for (let technology of this.activeTechnologies){
                    if(technology.layer !== null) {
                        if(technology.layer.indexOf(",") != -1) {
                            for(let layer of technology.layer.split(",")) {
                                let elem = classroom.querySelector('#' + layer)
                                if (elem){
                                    elem.style.opacity = 1
                                }
                            }
                        } else {
                            let elem = classroom.querySelector('#' + technology.layer)
                            if (elem){
                                elem.style.opacity = 1
                            }
                        }
                    }
                }
            },
            resetTechnologies() {
                let classroom = this.$refs['classroom']
                classroom.querySelectorAll('.technology').forEach(function(el){
                    el.style.opacity = 0
                })
            }
        }
    };
</script>

<style scoped lang="scss">
    .classroom {
        width: 100%;
    }
</style>
